export const stepEnum = {
  INITIAL: 'initial',
  BANSELECT: 'banselect',
  CREDITCARD: 'creditcard',
  SELECTAMOUNT: 'selectamount',
  SELECTPAYMENTTYPE: 'selectpaymenttype',
  NOACCOUNTS: 'noaccounts',
  PAYMENTSUCCESS: 'paymentsuccess',
  BITPENDING: 'bitpending',
  PAYMENTFAILED: 'paymentfailed',
  PAYMENTFAILEDENERGY: 'paymentfailedenergy',
  PAYMENTFAILEDWITHOUTBITOPTION: 'paymentfailedwithoutbitoption',
  CREDITPAYMENTERROR: 'creditpaymenterror',
  CREDITPAYMENTERRORENERGY: 'creditpaymenterrorenergy',
  GENERALERROR: 'generalerror',
  BITGENERALERROR: 'bitgeneralerror',
  BITPAYMENTFAILED: 'bitpaymentfailed',
  BITPAYMENTIMPOSSIBLE: 'bitpaymentimpossible',
  BITPENDINGPOPUP: 'bitpendingpopup',
  INCORRECTUSER: 'incorrectuser',
  //update payment
  SELECTUPDATEPAYMENTBAN: 'selectupdatepaymentban',
  SELECTUPDATEPAYMENTTYPE: 'selectupdatepaymenttype',
  BANKRANCHSELECTION: 'bankbranchselection',
  BANKFORMSIGNATURE: 'bankformsignature',
  UPDATEPAYMENTSUCCESS: 'updatepaymentsuccess',
  UPDATEPAYMENTFAILEDBANK: 'updatepaymentfailedbank',
  UPDATEPAYMENTFAILEDCC: 'updatepaymentfailedcc',
  SENDSMSENTITYPAYMENT: 'sendsmsentitypayment',
  SENDSMSENTITYPAYMENTSUCCESS: 'sendsmsentitypaymentsuccess',
};

export const paymentType = {
  CREDITCARD: 'creditcard',
  BIT: 'bit',
};

export const paymentAction = {
  PAYMENT: 'payment',
  PAYMENT_AND_UPDATE: 'payment_and_update',
  UPDATE_PAYMENT_METHOD: 'update_payment_method',
};

export const bitPaymentStatusEnum = {
  NEW: 'new',
  BITPENDING: 'bitpending',
  DONEWITHFU: 'donewithfu',
  DONEWITHERROR: 'donewitherror',
  PAID: 'paid',
  CANCELLED: 'cancelled',
  FAILEDTOCANCEL: 'failedtocancel',
};

export const deviceType = {
  ANDROID: 'Android',
  IOS: 'IOS',
  DESKTOP: 'Desktop',
};

export const banImageEnum = {
  BANS_WITH_DEBT_OR_PAYMENT_METHOD_ISSUE: 1,
  OTHER_BANS: 2,
};

export const popupEnum = {
  PAYMENT_METHOD_ISSUE: 'paymentmethodissue',
  BIT_PENDING: 'bitpending',
  UPDATE_ALL_CHECK_BOX: 'updateallcheckbox',
  UPDATE_PAYMENT_BANS_DETAILS: 'updatepaymentbansdetails',
  BANK_NOT_IN_LIST: 'banknotinlist',
  BANK_ACCOUNT_MISMATCH: 'bankaccountmismatch',
  SIGNATURE_REQUIRED: 'signaturerequired',
  DEBT_FIRST: 'debtfirst',
  DEBT_FIRST_MAX: 'debtfirstmax',
};

const financeCallNumber1 = () => window.Config?.financeCallNumber1;
const energyCallCenter = () => window.Config?.energyCallCenter;
export const contactUsBankNotInList = {
  title: {
    get value() {
      return `חייגו ${financeCallNumber1()} לנציג שירות`;
    },
  },
  actionType: {value: 'phone'},
  phoneNumber: {
    get value() {
      return financeCallNumber1();
    },
  },
};

export const contactUsEnergy = {
  title: {
    get value() {
      return `לעדכון חייגו ${energyCallCenter()}`;
    },
  },
  actionType: {value: 'phone'},
  phoneNumber: {
    get value() {
      return energyCallCenter();
    },
  },
  icon: {value: {url: require('../images/contact-us.png')}},
};
export const contactUsEnergyCC = {
  title: {
    get value() {
      return `חייגו ${energyCallCenter()} לנציג שירות`;
    },
  },
  actionType: {value: 'phone'},
  phoneNumber: {
    get value() {
      return energyCallCenter();
    },
  },
  icon: {value: {url: require('../images/contact-us.png')}},
};
export const contactUsEnergyMob = {
  title: {
    get value() {
      return `חייגו ${energyCallCenter()}`;
    },
  },
  actionType: {value: 'phone'},
  phoneNumber: {
    get value() {
      return energyCallCenter();
    },
  },
  icon: {value: {url: require('../images/contact-us.png')}},
};

/** Steps without mobile bottom-button layout (list screens, bit results, etc.). New form steps get layout by default. */
export const stepsWithoutBottomButtonLayout = [
  stepEnum.INITIAL,
  stepEnum.BANSELECT,
  stepEnum.NOACCOUNTS,
  stepEnum.BITPENDING,
  stepEnum.BITGENERALERROR,
  stepEnum.BITPAYMENTFAILED,
  stepEnum.BITPAYMENTIMPOSSIBLE,
  stepEnum.INCORRECTUSER,
  stepEnum.BITPENDINGPOPUP,
];

export const shouldUseBottomButtonLayout = (currentStep) => Boolean(currentStep) && !stepsWithoutBottomButtonLayout.includes(currentStep);
export const backButtonVisibleSteps = [
  stepEnum.SELECTAMOUNT,
  stepEnum.SELECTPAYMENTTYPE,
  stepEnum.CREDITCARD,
  stepEnum.SELECTUPDATEPAYMENTTYPE,
  stepEnum.SELECTUPDATEPAYMENTBAN,
  stepEnum.BANKRANCHSELECTION,
  stepEnum.BANKFORMSIGNATURE,
  stepEnum.SENDSMSENTITYPAYMENT,
];

export const message = {
  generalerror: {
    title: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
    icon: require('../images/error.svg'),
    showContactUsTitle: true,
    contactUs: {
      title: {
        get value() {
          return `להתקשר עכשיו ${financeCallNumber1()}`;
        },
      },
      actionType: {value: 'phone'},
      phoneNumber: {
        get value() {
          return financeCallNumber1();
        },
      },
    },
  },
  paymentfailedenergy: {
    title: 'משהו השתבש ולא הצלחנו <br />להשלים את החיוב',
    secondTitle: 'לפרטים נוספים יש לפנות לנציג שירות',
    icon: require('../images/failed.svg'),
    showContactUsTitle: true,
    contactUs: {
      title: {
        get value() {
          return `חייגו ${energyCallCenter()}`;
        },
      },
      actionType: {value: 'phone'},
      phoneNumber: {
        get value() {
          return energyCallCenter();
        },
      },
    },
  },
  paymentfailedwithoutbitoption: {
    title: 'משהו השתבש ולא הצלחנו <br />להשלים את החיוב',
    secondTitle: 'לפרטים נוספים יש לפנות לנציג שירות',
    icon: require('../images/failed.svg'),
    showContactUsTitle: true,
    contactUs: {
      title: {
        get value() {
          return `חייגו ${financeCallNumber1()}`;
        },
      },
      actionType: {value: 'phone'},
      phoneNumber: {
        get value() {
          return financeCallNumber1();
        },
      },
    },
  },
  creditpaymenterror: {
    title: 'מספר התשלומים לסוג אשראי זה <br /> חייב להיות מעל 2',
    icon: require('../images/error.svg'),
    showContactUsTitle: true,
    contactUs: {
      title: {
        get value() {
          return `להתקשר עכשיו ${financeCallNumber1()}`;
        },
      },
      actionType: {value: 'phone'},
      phoneNumber: {
        get value() {
          return financeCallNumber1();
        },
      },
    },
  },
  updatepaymentfailedbank: {
    title: 'משהו השתבש והוראת הקבע <br /> לא הוגדרה',
    icon: require('../images/failed.svg'),
    showContactUsTitle: false,
    contactUs: {
      title: {
        get value() {
          return `חייגו ${financeCallNumber1()} לנציג שירות`;
        },
      },
      actionType: {value: 'phone'},
      phoneNumber: {
        get value() {
          return financeCallNumber1();
        },
      },
    },
  },
  updatepaymentfailedcc: {
    title: 'משהו השתבש ולא הצלחנו <br />לעדכן את אמצעי התשלום',
    icon: require('../images/failed.svg'),
    showContactUsTitle: false,
    contactUs: {
      title: {
        get value() {
          return `חייגו ${financeCallNumber1()} לנציג שירות`;
        },
      },
      actionType: {value: 'phone'},
      phoneNumber: {
        get value() {
          return financeCallNumber1();
        },
      },
    },
  },
};
